export default __webpack_public_path__ + "static/media/target-1@2x.be60f262.png";